module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_5.cd4d6f0b.png";